// extracted by mini-css-extract-plugin
export default {"block":"Dc","items":"Ec"};